import { Injectable } from '@angular/core';
import { TokenRefresh } from '@shared/interfaces/auth/token-refresh.interface';
import { map } from 'rxjs/operators';
import { Response } from '@shared/models/response.model';
import { User } from '@shared/models/user/user.model';
import { HttpClient } from '@angular/common/http';
import { ResetPassword } from '@shared/interfaces/auth/reset-password.interface';
import { Router } from '@angular/router';
import { BaseHttpService } from '@shared/services/base-http.service';
import { Login } from '@shared/interfaces/auth/login-data.interface';
import { Register } from '@shared/interfaces/auth/register-data.interface';
import { ResetPasswordEmail } from '@shared/interfaces/auth/reset-password-email.interface';
import { TokenParams } from '@shared/interfaces/auth/token-params.interface';
import { Observable } from 'rxjs';
import { SocialMediaUser } from '@shared/interfaces/auth/social-media-user.interface';

@Injectable()
export class AuthorizationService {
  constructor(public http: HttpClient, public router: Router, public baseHttp: BaseHttpService) {}

  loginData(pack: Login): Observable<TokenRefresh> {
    return this.baseHttp.post('/login', pack).pipe(map((resp) => resp as TokenRefresh));
  }

  socialMediaAuth(pack: SocialMediaUser): Observable<TokenRefresh> {
    return this.baseHttp
      .post('/login/oauth/connect/' + pack.provider + '/loginOrRegister', pack)
      .pipe(map((resp) => resp as TokenRefresh));
  }

  userData(): Observable<Response<User>> {
    return this.baseHttp.get('/user').pipe(map((resp) => resp as Response<User>));
  }

  registerData(pack: Register): Observable<Response<User>> {
    return this.baseHttp
      .post('/hero/register', { user: pack })
      .pipe(map((resp) => resp as Response<User>));
  }

  resetPassData(pack: ResetPasswordEmail): Observable<Response<User>> {
    return this.baseHttp
      .post('/resetting/send-email', pack)
      .pipe(map((resp) => resp as Response<User>));
  }

  resetPassConfirmData(pack: ResetPassword): Observable<Response<User>> {
    return this.baseHttp
      .post('/resetting/reset-password/' + pack.token, { data: pack })
      .pipe(map((resp) => resp as Response<User>));
  }

  resetPassFormConfirmData(pack: ResetPassword): Observable<Response<User>> {
    return this.baseHttp
      .post('/resetting/reset-password-form/' + pack.token, { data: pack })
      .pipe(map((resp) => resp as Response<User>));
  }

  confirmEmailData(pack: TokenParams): Observable<TokenRefresh> {
    return this.baseHttp
      .get('/confirm-email/' + pack.token)
      .pipe(map((resp) => resp as TokenRefresh));
  }
}
